import api from './api'
import type {
  User,
  UserOnboardingPayload,
  UserProfileUpdate,
  UserStats,
} from '@/types'

export const userService = {
  async updateProfile(data: UserProfileUpdate): Promise<User> {
    const { data: user } = await api.patch<User>('/me', data)
    return user
  },

  async completeOnboarding(payload: UserOnboardingPayload): Promise<User> {
    const { data: user } = await api.post<User>('/me/onboarding', payload)
    return user
  },

async getStats(): Promise<UserStats> {
    const { data } = await api.get<UserStats>('/me/stats')
    return data
  },
}
